import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deletePermission(
  permissionUuid: string
): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/iam/permission/${permissionUuid}`)
}
